import { createFileRoute, Navigate } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { AgencyNewSalonPage } from '@/features/agency';
import { useAgencyViewerAccess } from '@/features/agency/hooks/use-agency-viewer-access';
import { formatDocumentTitle } from '@/lib/document-title';

export const Route = createFileRoute('/_auth/agency/salons/new')({
  component: AgencyNewSalonRoute,
});

/**
 * Agency admins and Salon setup members only. Everyone else (the API returns 403)
 * is sent back to the Salons page once their access is known.
 */
function AgencyNewSalonRoute() {
  const access = useAgencyViewerAccess();

  if (access.isLoading) return null;
  // A failed access check is not a "no": offer a retry instead of bouncing a setup member.
  if (access.isError) {
    return (
      <p
        role="alert"
        className="mx-auto w-full max-w-2xl rounded-[14px] border border-dashed border-clovie-border px-4 py-3 text-base leading-6 text-clovie-muted"
      >
        Couldn’t check your agency access.{' '}
        <button
          type="button"
          onClick={() => void access.refetch()}
          className="inline-flex min-h-11 items-center rounded-[var(--r-md)] font-semibold text-clovie-brand-dark underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-clovie-brand"
        >
          Try again
        </button>
      </p>
    );
  }
  if (!access.canManageSalonSetup) return <Navigate to="/agency/salons" replace />;

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('New Salon')}</title>
      </Helmet>
      <AgencyNewSalonPage canChoosePlan={access.isAdmin} />
    </>
  );
}
